module.exports = __webpack_public_path__ + "static/img/rank04.71e7a7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v2/rank04.jpg
// module id = OdpO
// module chunks = 76